import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.values.js";
import { getRecentAlarmsApi, updateDeviceConfigApi, getLastEtcDataApi } from '@/api';
import { siteCountyOptions } from '@/utils/options';

import { DateTime } from 'luxon';
export default {
  name: 'FactoryStatus',
  data: function data() {
    return {
      DateTime: DateTime,
      siteCountyOptions: siteCountyOptions,
      meterFactory: '',
      meterData: null,
      filterSite: [],
      fakeSettingArray: ['(依)變流器flag', '電表', '日照', '模溫', '環溫', '風速', '水位'],
      settingArray: {},
      invSelect: 'irr',
      recentalarmsData: [],
      updateFactory: '',
      updateDocID: '',
      // filterTitle: [
      //   {
      //     name: '案場',
      //     sortName: 'factoryName',
      //     sort: true
      //   },
      //   {
      //     name: '案場編號',
      //     sortName: 'projectNumber',
      //     sort: true
      //   },
      //   {
      //     name: '縣市',
      //     sortName: 'county',
      //     sort: true
      //   },
      //   {
      //     name: '工程師',
      //     sortName: 'maintainer',
      //     sort: true
      //   },
      //   {
      //     name: '工程師工號',
      //     sortName: 'maintainerNum',
      //     sort: true
      //   },
      //   {
      //     name: '連線時間',
      //     sortName: 'timestamp',
      //     sort: true
      //   }
      // ],
      thTitle: [{
        text: '案場',
        value: 'factoryName',
        sort: true
      }, {
        text: '案場編號',
        value: 'projectNumber',
        sort: true
      }, {
        text: '縣市',
        value: 'county',
        sort: true
      }, {
        text: '工程師',
        value: 'maintainer',
        sort: true
      }, {
        text: '工程師工號',
        value: 'maintainerNum',
        sort: true
      }, {
        text: '裝置狀態',
        value: 'level',
        sort: false
      }, {
        text: '連線時間',
        value: 'timestamp',
        sort: true
      }],
      searchInput: '',
      selectedFilter: {
        text: '案場',
        value: 'factoryName',
        sort: true
      },
      configExist: true,
      loadingData: false
    };
  },
  computed: {
    filterOptions: function filterOptions() {
      return this.thTitle.filter(function (x) {
        return x.name !== '影響' && x.text !== '開始時間';
      }).map(function (item) {
        return {
          text: item.text,
          value: item
        };
      });
    },
    factoryStatusFilterSearch: function factoryStatusFilterSearch() {
      var _this = this;
      this.recentalarmsData.forEach(function (x) {
        if (x.timestamp === null) x.timestamp = '';
      });
      if (this.filterSite.length) {
        return this.recentalarmsData.filter(function (resources) {
          return resources["".concat(_this.selectedFilter.value)].match(_this.searchInput) && _this.filterSite.includes(resources['county']);
        });
      }
      return this.recentalarmsData.filter(function (resources) {
        return resources["".concat(_this.selectedFilter.value)].match(_this.searchInput);
      });
    }
  },
  methods: {
    goMoxaPage: function goMoxaPage() {
      window.open('https://dlm.thingsprocloud.com/login');
    },
    transferConfig: function transferConfig(key) {
      if (key === 'invs') return '變流器';
      if (key === 'meter') return '電表';
      if (key === 'S40') return 'S40';
      if (key === 'irr') return '日照計';
      if (key === 'moduleTemp') return '模組溫度';
      if (key === 'envTemp') return '環溫';
      if (key === 'windSpeed') return '風速';
      if (key === 'waterLevel') return '水位';
      if (key === 'mppt') return 'mppt';
      if (key === 'eff') return '效率';
      if (key === 'eNetV') return '電網電壓';
      if (key === 'eNetFreq') return '電網頻率';
      if (key === 'temp') return '溫度';
      return key;
    },
    StatusFunction: function StatusFunction(obj) {
      var gray = 'color: #787878; opacity: 0.6';
      var red = 'color: #FF2D2D';
      var yellow = 'color: #ffe606';
      var green = 'color: green';
      if (obj === null) return gray;
      if (typeof obj === 'boolean') {
        if (obj) {
          return red;
        } else {
          return green;
        }
      }
      if (obj.length > 0) {
        var noAlert = obj.every(function (x) {
          return x.noAlert === true;
        });
        if (noAlert) {
          return green;
        } else {
          return yellow;
        }
      } else {
        return green; // fix meter
      }
    },
    alarmsLevel: function alarmsLevel(arr) {
      arr.forEach(function (x) {
        var vlevel = 9;
        x.level = null;
        for (var _i = 0, _Object$entries = Object.entries(Object.entries(x.statusResult)); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            index = _Object$entries$_i[0],
            _Object$entries$_i$ = _slicedToArray(_Object$entries$_i[1], 2),
            key = _Object$entries$_i$[0],
            value = _Object$entries$_i$[1];
          if (key === 'disconnect' && value) x.level = Math.pow(2, 10);
          if (value && value.length > 0 && !value.every(function (y) {
            return y.noAlert === true;
          })) {
            var levelIndex = index;
            if (key === 'invsTotalStatus') levelIndex = 1;
            x.level = x.level ? x.level + Math.pow(2, vlevel - levelIndex) : Math.pow(2, vlevel - levelIndex);
          }
          if (value === null) x.level++;
        }
        if (!x.level) x.level = 0;
      });
      return arr;
    },
    openSetting: function openSetting(obj, factoryName, docId, configObj) {
      this.configExist = true;
      var defaultConfig = configObj;
      this.settingArray = obj !== undefined ? obj : defaultConfig;
      // this.invSelect = obj.invs.irr
      this.configExist = obj !== undefined ? !this.configExist : this.configExist;
      this.updateFactory = factoryName;
      this.updateDocID = docId;
      this.$bvModal.show('settingModal');
    },
    sortHistoryData: function sortHistoryData(str, idx) {
      this.recentalarmsData = this.recentalarmsData.sort(function (a, b) {
        if (a["".concat(str)] === null) a["".concat(str)] = '';
        if (b["".concat(str)] === null) b["".concat(str)] = '';
        if (a["".concat(str)] > b["".concat(str)]) return 1;
        if (a["".concat(str)] < b["".concat(str)]) return -1;
        return 0;
      });
      if (!this.thTitle[idx].sort) {
        this.recentalarmsData = this.recentalarmsData.reverse();
      }
      this.thTitle[idx].sort = !this.thTitle[idx].sort;
    },
    sortAlertMsg: function sortAlertMsg(array) {
      array.forEach(function (x) {
        if (x.statusResult.invsTotalStatus !== null) {
          var alertArray = x.statusResult.invsTotalStatus.filter(function (y) {
            return y.noAlert === false;
          });
          var noAlertArray = x.statusResult.invsTotalStatus.filter(function (y) {
            return y.noAlert === true;
          });
          var sortArray = alertArray.concat(noAlertArray);
          x.statusResult.invsTotalStatus = sortArray;
        }
      });
      return array;
    },
    getRecentAlarms: function getRecentAlarms() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _recentalarms$data;
        var recentalarms;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loadingData = true;
                _this2.recentalarmsData = [];
                _context.next = 4;
                return getRecentAlarmsApi();
              case 4:
                recentalarms = _context.sent;
                if (recentalarms !== null && recentalarms !== void 0 && (_recentalarms$data = recentalarms.data) !== null && _recentalarms$data !== void 0 && _recentalarms$data.success) {
                  _this2.rebuildInvsResult(recentalarms.data.data);
                  _this2.recentalarmsData = _this2.alarmsLevel(recentalarms.data.data);
                  _this2.recentalarmsData = _this2.sortAlertMsg(_this2.recentalarmsData);
                  _this2.thTitle[5].sort = false;
                  _this2.sortHistoryData('level', 5);
                }
                _this2.loadingData = false;
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rebuildInvsResult: function rebuildInvsResult(array) {
      array.forEach(function (x) {
        if (x.statusResult.invs !== null) {
          var invsObjArray = Object.values(x.statusResult.invs);
          var resultArray = [];
          invsObjArray.forEach(function (y) {
            if (y !== null) {
              resultArray = resultArray.concat(y);
            }
          });
          x.statusResult.invsTotalStatus = resultArray;
        } else {
          x.statusResult.invsTotalStatus = null;
        }
      });
    },
    upDateConfig: function upDateConfig(arr) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _upDateConfig$data;
        var deviceConfig, upDateConfig;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                deviceConfig = arr;
                _context2.next = 3;
                return updateDeviceConfigApi(_this3.updateFactory, _this3.updateDocID, deviceConfig);
              case 3:
                upDateConfig = _context2.sent;
                if (upDateConfig !== null && upDateConfig !== void 0 && (_upDateConfig$data = upDateConfig.data) !== null && _upDateConfig$data !== void 0 && _upDateConfig$data.success) {
                  _this3.$swal('上傳成功');
                }
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    showMeter: function showMeter(factoryName, meterExist) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(meterExist === 'color: #787878; opacity: 0.6')) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return");
              case 2:
                _this4.meterFactory = factoryName;
                _context3.next = 5;
                return _this4.getlastetcdata(factoryName);
              case 5:
                _this4.$bvModal.show('meterModal');
              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getlastetcdata: function getlastetcdata(factoryName) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _lastEtcData$data;
        var lastEtcData;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return getLastEtcDataApi(factoryName);
              case 2:
                lastEtcData = _context4.sent;
                if (lastEtcData !== null && lastEtcData !== void 0 && (_lastEtcData$data = lastEtcData.data) !== null && _lastEtcData$data !== void 0 && _lastEtcData$data.success) {
                  _this5.meterData = lastEtcData.data.data;
                }
              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  },
  created: function created() {
    this.getRecentAlarms();
  }
};